import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Settings, Save } from 'lucide-react';

const SiteConfig = () => {
  const [config, setConfig] = useState({
    siteName: 'Bodega Spinoglio',
    email: 'contacto@bodegaspinoglio.com',
    phone: '+598 123 456 789',
    address: 'Canelones, Uruguay',
    openingHours: 'Lunes a Viernes: 10:00 - 18:00',
    facebook: 'https://facebook.com/bodegaspinoglio',
    instagram: 'https://instagram.com/bodegaspinoglio',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Configuración guardada (funcionalidad en desarrollo)');
  };

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Configuración del Sitio</h1>
        <p className="text-gray-600">Administra la información general del sitio web</p>
      </div>

      <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 space-y-6">
        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <label className="block text-gray-700 font-medium mb-2">Nombre del Sitio</label>
            <input
              type="text"
              value={config.siteName}
              onChange={(e) => setConfig({ ...config, siteName: e.target.value })}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-2">Email de Contacto</label>
            <input
              type="email"
              value={config.email}
              onChange={(e) => setConfig({ ...config, email: e.target.value })}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-2">Teléfono</label>
            <input
              type="text"
              value={config.phone}
              onChange={(e) => setConfig({ ...config, phone: e.target.value })}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-2">Dirección</label>
            <input
              type="text"
              value={config.address}
              onChange={(e) => setConfig({ ...config, address: e.target.value })}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-2">Horarios</label>
            <input
              type="text"
              value={config.openingHours}
              onChange={(e) => setConfig({ ...config, openingHours: e.target.value })}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-2">Facebook</label>
            <input
              type="url"
              value={config.facebook}
              onChange={(e) => setConfig({ ...config, facebook: e.target.value })}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-2">Instagram</label>
            <input
              type="url"
              value={config.instagram}
              onChange={(e) => setConfig({ ...config, instagram: e.target.value })}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent"
            />
          </div>
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            className="flex items-center gap-2 px-6 py-3 text-white rounded-lg font-semibold transition-all shadow-lg hover:scale-105"
            style={{background: 'linear-gradient(135deg, #D4AF37 0%, #C9A961 100%)'}}
          >
            <Save className="h-5 w-5" />
            Guardar Configuración
          </button>
        </div>
      </form>
    </div>
  );
};

export default SiteConfig;